export class Session {
    constructor(public series: string,
                public tokenDate: Date,
                public ipAddress: string,
                public userAgent: string) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/sessions/session.model.ts